import React, { useState } from 'react';
import { ChevronDown } from 'lucide-react';
export function FAQSection() {
  const faqs = [{
    q: '¿Tengo que dejar de comer tortillas?',
    a: 'No, aprenderás a elegir las que no te inflaman (y te enseñamos dónde comprarlas).'
  }, {
    q: '¿Es una dieta de hambre?',
    a: 'Al contrario, el plan incluye grasas saludables y proteínas que te mantendrán satisfecha todo el día.'
  }, {
    q: '¿Los ingredientes son caros?',
    a: 'Usamos alimentos de supermercado común, solo cambiamos la marca o el tipo de ingrediente por opciones más puras.'
  }, {
    q: '¿Funciona si tengo hipotiroidismo?',
    a: 'Sí, reducir la inflamación sistémica es uno de los pasos más importantes para mejorar la función tiroidea.'
  }];
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  const toggleFAQ = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };
  return <section className="bg-white py-20 md:py-28" data-id="element-12">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 max-w-4xl" data-id="element-13">
        <div className="text-center mb-16" data-id="element-14">
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-heading font-bold text-forest mb-6" data-id="element-15">
            Preguntas Frecuentes
          </h2>
          <div className="w-24 h-1 bg-gold mx-auto" data-id="element-16"></div>
        </div>

        <div className="space-y-4" data-id="element-17">
          {faqs.map((faq, index) => <div key={index} className="border border-sage/50 rounded-sm overflow-hidden bg-cream/30 hover:bg-cream/50 transition-colors duration-300" data-id="element-18">
              <button onClick={() => toggleFAQ(index)} className="w-full flex items-center justify-between p-6 text-left focus:outline-none focus-visible:ring-2 focus-visible:ring-gold focus-visible:ring-opacity-50" aria-expanded={openIndex === index} data-id="element-19">
                <span className="text-lg md:text-xl font-heading font-bold text-forest pr-8" data-id="element-20">
                  {faq.q}
                </span>
                <ChevronDown className={`w-6 h-6 text-gold transform transition-transform duration-300 flex-shrink-0 ${openIndex === index ? 'rotate-180' : ''}`} data-id="element-21" />
              </button>

              <div className={`transition-all duration-300 ease-in-out overflow-hidden ${openIndex === index ? 'max-h-96 opacity-100' : 'max-h-0 opacity-0'}`} data-id="element-22">
                <div className="p-6 pt-0 text-dark/80 font-body leading-relaxed border-t border-sage/20" data-id="element-23">
                  {faq.a}
                </div>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}